/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feeplans": {
        "nested": {
          "pricing": {
            "nested": {
              "HeadlineFeeRateName": {
                "values": {
                  "DEFAULT_HEADLINE_FEE_RATE_NAME_DO_NOT_USE": 0,
                  "CARD_PRESENT": 1,
                  "CARD_NOT_PRESENT": 2,
                  "ONLINE": 3,
                  "ONLINE_API": 4,
                  "ACH_API": 5,
                  "ACH_INVOICES": 6,
                  "AFTERPAY": 7,
                  "GIFT_CARD_LOAD": 8,
                  "APP_SUBSCRIPTIONS": 9,
                  "ACH_APP_SUBSCRIPTIONS": 10,
                  "APP_SUBSCRIPTIONS_MARKETPLACE": 11,
                  "CASH_BUSINESS": 12,
                  "INTERNAL_ACCOUNTS": 13
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feeplans?.nested?.pricing?.nested?.HeadlineFeeRateName) {
  $root.addJSON(jsonData);
}

/**
 * A list of canonical headline fee rates that can apply to a payment.
 *
 * SOURCE HeadlineFeeRateName @ squareup/feeplans/pricing/headline_fee_rates.proto at 9:1
 */
export const HeadlineFeeRateName = $root.lookupEnum('squareup.feeplans.pricing.HeadlineFeeRateName').values;